import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const employeeUpdateService = (data: any) => {
  return axiosInstance
    .put(ENDPOINTS.ADMIN.EMPLOYEE_MANAGEMENT.UPDATE, data)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
